<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
.amap-sug-result {
  z-index: 9999 !important;
}
</style>
